import { Injectable } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Store } from "@ngxs/store";
import { GetTransaction, SetWidgetData } from "../states/transactions/transactions.actions";
import { TransactionsState } from "../states/transactions/transactions.state";

@UntilDestroy()
@Injectable()
export class SideWidgetService {
    /**
     *
     */
    constructor(private store: Store) {}
    
    openSideWidget(transactionId: string) {
        this.store.dispatch(new GetTransaction(transactionId));
      }

      closeSideWidget() {
        this.store.dispatch(new SetWidgetData(null));
      }
}
